import {
  Container,
  Contain,
  DivOne,
  DivTwo,
  DivThree,
  DivFour,
  DivFive,
  DivSix,
  DivSeven,
  DivEight,
  DivNine,
  DivTen,
  DivEleven,
  DivTwelve,
} from "./style";

export const BackgroundAnimation = () => {
  return (
    <Container>
      <Contain>
        <DivOne />
        <DivTwo />
        <DivThree />
        <DivFour />
        <DivFive />
        <DivSix />
        <DivSeven />
        <DivEight />
        <DivNine />
        <DivTen />
        <DivEleven />
        <DivTwelve />
      </Contain>
    </Container>
  );
};
